import React from 'react';

const Contact = () => {
    const openHours = () => {
        alert('Our business hours:\nMonday - Friday: 9AM - 6PM\nSaturday: 10AM - 4PM\nSunday: Closed');
    };

    return (
        <section className="contact" id="contact">
            <div className="container">
                <div className="section-title">
                    <h2>Contact</h2>
                    <p>Get in touch with us for any queries</p>
                </div>

                <div className="contact-container">
                    <div className="contact-buttons">
                        <a href="https://maps.app.goo.gl/sK9Fu4qjd8rB6joF6" target="_blank" rel="noopener noreferrer" className="contact-btn">
                            <div className="icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="contact-details">
                                <h4>Location</h4>
                                <p>Kavitha Road ,Kacherithazham , Muvattupuzha, Ernakulam-686661</p>
                            </div>
                        </a>

                        <a href="tel:+919745695978" className="contact-btn">
                            <div className="icon">
                                <i className="fas fa-phone"></i>
                            </div>
                            <div className="contact-details">
                                <h4>Phone</h4>
                                <p>+91 97456 95978</p>
                            </div>
                        </a>

                        <a href="mailto:r4rubense@gmail.com" className="contact-btn">
                            <div className="icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div className="contact-details">
                                <h4>Email</h4>
                                <p>r4rubense@gmail.com</p>
                            </div>
                        </a>

                        <div className="contact-btn" onClick={openHours}>
                            <div className="icon">
                                <i className="fas fa-clock"></i>
                            </div>
                            <div className="contact-details">
                                <h4>Business Hours</h4>
                                <p>Mon-Fri: 9AM-6PM | Sat: 10AM-4PM</p>
                            </div>
                        </div>
                    </div>

                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.982855999892!2d76.573807!3d9.979848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNTgnNDcuNCJOIDc2wrAzNCcyNS43IkU!5e0!3m2!1sen!2sin!4v1695600000000"
                            width="100%"
                            height="450"
                            style={{border:0}}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Thaksha Architects Location">
                        </iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;